import { MailingAddress } from '../shared/address.ts';
import { CountryEnum } from '../shared/geo.ts';

export enum CheckoutAddressTypeEnum {
  Billing = 'billing',
  Mailing = 'mailing',
}

export enum CheckoutContactFieldsEnum {
  // Make sure all of these keys match their associated keys in CheckoutContactInfo
  // Couldn't simply dynamically assign the properties since some of them are optional, mixed typings, etc.
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  Phone = 'phone',
  isGroup = 'isGroup',
  GroupType = 'groupType',
  GroupName = 'groupName',
}

export type CheckoutContactInfo = MailingAddress & {
  firstName?: string;
  lastName: string;
  email: string;
  phone: string;
  isGroup?: boolean;
  groupType?: string;
  groupName?: string;
  clientTimezoneOffset?: number;
  mailingCountry: keyof typeof CountryEnum;
};
